import React from "react";
import PropTypes from "prop-types";
import { Button } from "@ts-digital/vrc";
import HeaderContent from "../../../components/headerContent";
import "./style.css";
import { useLocation, useNavigate } from "react-router-dom";

const Drawer = ({
  onClose,
  headerTitle,
  headerSubTitle,
  content,
  buttonContent,
  className=""
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div className={"drawer-container "+className}>
      <div className="close-container">
        <Button onClick={onClose}>x</Button>
      </div>
      <HeaderContent
        location={location}
        navigate={navigate}
        title={headerTitle}
        subtitle={headerSubTitle}
        miniHeader={true}
      />
      {content}
      <div className="button-box">
        <div className="button-details">{buttonContent}</div>
      </div>
    </div>
  );
};

Drawer.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default Drawer;
